import listActions from './listActions'

const allActions = {
    listActions
}

export default allActions